module.exports = __webpack_public_path__ + "static/media/rm_06-10.d2a456ac.png";